import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useFeatureIsOn } from '@growthbook/growthbook-react';

import styles from '../../style/components/account/UserBadges.module.scss';
import { getSocialFeatures } from '../../actions/social-features';

/**
 * UserBadges - Displays user badges in the account section
 * Shows all available badges with visual indication of achieved vs unachieved
 */
const UserBadges = ({ socialFeaturesData, getSocialFeaturesAction, selectedCourse }) => {
  // Check if the badges feature is enabled
  const showAchievementBadges = useFeatureIsOn('achievement-badges');

  // Fetch social features data when component mounts
  useEffect(() => {
    if (showAchievementBadges && selectedCourse?.id) {
      getSocialFeaturesAction(selectedCourse.id);
    }
  }, [showAchievementBadges, selectedCourse?.id, getSocialFeaturesAction]);

  // Don't render anything if feature flag is off or no data
  if (!showAchievementBadges || !socialFeaturesData?.data?.badges) {
    return null;
  }

  const { badges } = socialFeaturesData.data;

  return (
    <div className={styles.badgesContainer}>
      <h2 className={styles.badgesTitle}>Your Achievements</h2>
      <div className={styles.badgesList}>
        {badges.map((badge) => (
          <div key={badge.id} className={`${styles.badgeItem} ${!badge.achieved ? styles.unachieved : ''}`}>
            <div className={styles.badgeIconContainer}>
              <img src={badge.iconUrl} alt={badge.name} className={styles.badgeIcon} />
            </div>
            <div className={styles.badgeInfo}>
              <h3 className={styles.badgeName}>{badge.name}</h3>
              <p className={styles.badgeDescription}>{badge.description}</p>
              {!badge.achieved && (
                <div className={styles.badgeProgress}>
                  <div className={styles.progressBar}>
                    <div className={styles.progressFill} style={{ width: `${(badge.progress / badge.total) * 100}%` }}></div>
                  </div>
                  <span className={styles.progressText}>
                    {badge.progress}/{badge.total}
                  </span>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

UserBadges.propTypes = {
  socialFeaturesData: PropTypes.object,
  getSocialFeaturesAction: PropTypes.func.isRequired,
  selectedCourse: PropTypes.object,
  token: PropTypes.string.isRequired
};

const mapStateToProps = (state) => ({
  socialFeaturesData: state.socialFeaturesData,
  selectedCourse: state.courses?.selectedCourseDetails?.courseDetails
});

export default connect(mapStateToProps, {
  getSocialFeaturesAction: getSocialFeatures
})(UserBadges);
